// Required on every results view (see CLAUDE.md "Regulatory boundary").

export default function Disclaimer() {
  return (
    <p className="disclaimer" role="note">
      This tool presents publicly available fund holdings data for informational purposes only. It
      does not constitute financial advice. Always consult a qualified financial advisor before
      making investment decisions.
    </p>
  )
}
